"use strict";

exports.__esModule = true;
exports.createLinearScale = createLinearScale;
var _d3Scale = require("d3-scale");
/**
 * Create a linear scale.
 */
function createLinearScale(from, to, values) {
  return (0, _d3Scale.scaleLinear)().rangeRound([from, to]).domain([Math.min.apply(Math, values), Math.max.apply(Math, values)]);
}